import { createClient } from "@/lib/supabase/client";
import type { Notification, UserPreferences } from "@/lib/supabase/types";

export async function getUserPreferences(userId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("user_preferences")
		.select("*")
		.eq("user_id", userId)
		.single()
		.overrideTypes<UserPreferences>();
	return { data: data as UserPreferences, error };
}

export async function updateUserPreferences(
	userId: string,
	preferences: Partial<UserPreferences>,
) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("user_preferences")
		.update({ ...preferences })
		.eq("user_id", userId)
		.overrideTypes<UserPreferences>();
	return { data: data as UserPreferences | null, error };
}

export async function getNotifications(userId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("notifications")
		.select("*")
		.eq("user_id", userId)
		.eq("is_read", false)
		.order("created_at", { ascending: false })
		.limit(10)
		.overrideTypes<Notification[]>();
	return { data, error };
}

export async function markNotificationAsRead(notificationId: string) {
	const supabase = createClient();
	const { data, error } = await supabase
		.from("notifications")
		.update({ is_read: true })
		.eq("id", notificationId)
		.single();
	return { data, error };
}
